<div class="text-price font-weight-bold">
  <div [ngClass]="{ 'line-through-price': isDiscountedPriceVisible }" *ngIf="isPriceVisible">
    {{ product.price | phCurrency }}
  </div>
  <div class="text-pink" *ngIf="isDiscountedPriceVisible">
    {{ product.discountedPrice | phCurrency }}
  </div>
</div>
